import React from 'react';

import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { layout, spacing } from 'styles/constants';

const FORM_SPACING = spacing.$1;

const styles = StyleSheet.create({
  billingAptWrapper: {
    flexGrow: 1,
    marginBottom: FORM_SPACING,
    width: layout.full,
  },
  billingCityWrapper: {
    flexBasis: '60%',
    marginBottom: FORM_SPACING,
    marginRight: '5%',
  },
  billingStateWrapper: {
    flexBasis: '35%',
    marginBottom: FORM_SPACING,
  },
  billingZipWrapper: {
    marginBottom: FORM_SPACING,
    width: layout.full,
  },
  countrySelectWrapper: {
    flexBasis: '100%',
    marginBottom: FORM_SPACING,
  },
  defaultContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: spacing.$2,
    width: layout.full,
  },
  nameOnCardWrapper: {
    marginBottom: FORM_SPACING,
  },
  saveCardContainer: {
    paddingBottom: spacing.$2,
    paddingHorizontal: FORM_SPACING,
    paddingLeft: spacing.$1,
  },
  streetAddressWrapper: {
    flexBasis: '100%',
    marginBottom: FORM_SPACING,
  },
});

const createBox = (baseStyle: ViewStyle) => ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [baseStyle, style] });

export const StyledSaveCardContainer = createBox(styles.saveCardContainer);

export const StyledBillingCityWrapper = createBox(styles.billingCityWrapper);

export const StyledBillingStateWrapper = createBox(styles.billingStateWrapper);

export const StyledStreetAddressWrapper = createBox(styles.streetAddressWrapper);

export const StyledBillingAptWrapper = createBox(styles.billingAptWrapper);

export const StyledBillingZipWrapper = createBox(styles.billingZipWrapper);

export const StyledNameOnCardWrapper = createBox(styles.nameOnCardWrapper);

export const StyledCountrySelectWrapper = createBox(styles.countrySelectWrapper);

export const DefaultContainer = createBox(styles.defaultContainer);
